let imageService: ImageResizeService

export function useImageResizeService(): ImageResizeService | null {
  const runtimeConfig = useRuntimeConfig()

  const initializeService = () => {
    if (imageService) return imageService

    // Get the runtime configuration for image resizing
    const resizeImageEnabled = runtimeConfig.public.RESIZE_IMAGE_ENABLED === "true"
    const imageSize: number = Number(runtimeConfig.public.RESIZE_IMAGE_SIZE)
    const imageOutputType: ImageResizeOutputType = runtimeConfig.public.RESIZE_IMAGE_OUTPUT_TYPE as ImageResizeOutputType

    // If image resizing is not enabled, return null
    if (!resizeImageEnabled) return null

    // Create a new instance of the ImageResizeService
    imageService = new ImageResizeService(
      {
        imageSize,
        type: imageOutputType,
      },
      new PicaImageResizer(),
    )

    return imageService
  }

  return initializeService()
}
